<template lang="html">
  <div class="dashboard">
    <!-- <v-header :name="name" :isDashboard="!child" :onBack="true" @backClick="backToDashboard"></v-header> -->
    <v-header :name="name" isDashboard></v-header>
    <div class="container">
      <div class="left">
        <div class="item1">
          <v-item2></v-item2>
        </div>
        <div class="item2">
          <v-item5></v-item5>
        </div>
        <img class="lf" src="../../../assets/img/chaye/lf.png">
        <div class="item3">
          <v-table></v-table>
        </div>
      </div>
      <div class="center">
        <v-center :outputValue="outputValue" :productionScale="productionScale" ></v-center>
      </div>
      <div class="right">
         <div class="item4">
          <v-item1></v-item1>
        </div>
        <div class="item5">
         <v-item3></v-item3>
        </div>
        <img class="rl" src="../../../assets/img/chaye/rl.png">
        <div class="item6">
          <v-table2></v-table2>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import header from "components/common/chayeheader";
import item1 from "./components/item1";
import item2 from "./components/item2";
import item3 from "./components/item3";
import center from "./components/center";
import item4 from "./components/item4";
import item5 from "./components/item5";
import item6 from "./components/item6";
import table2 from "./components/table2";


import planting from "./components/planting";

import generatingData from "./components/generatingData";
import salesData from "./components/salesData";
import table from "./components/table";
import pie from "./components/pie";
import bar from "./components/bar";
import harvestingPlan from "./components/harvestingPlan";
import ev from "./components/ev";
import video from "./components/video";
import group from "./components/group";
import list from "./components/list";

export default {
  data() {
    return {
      show: false,
      name: "浙江省农产品追溯数据舱",
      outputValue: "",
      productionScale: "",
      salesData: [],
      salesDataBar: [],
      salesDataRealTime: [],
      timerDashboard: null
    };
  },
  async mounted() {
    this.show = true;
  },
  beforeDestroy() {
    clearInterval(this.timerDashboard);
    this.timerDashboard = null;
  },
  methods: {},
  components: {
    "v-header": header,
    "v-item1": item1,
    "v-item2": item2,
    "v-item3": item3,
    "v-center": center,
    "v-item4": item4,
    "v-item5": item5,
    "v-item6": item6,
    "v-salesData": salesData,
    "v-table": table,
    "v-table2": table2,
    "v-harvestingPlan": harvestingPlan,
    "v-generatingData": generatingData,
    "v-pie": pie,
    "v-bar": bar,
    "v-list": list,
    "v-ev": ev,
    "v-video": video,
    "v-planting": planting,
    "v-group": group
  }
};
</script>

<style lang="less" scoped>
html,
body {
  width: 100%;
  height: 100%;
  width: 100vw;
  height: 100vh;
}

.dashboard {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-size: 100% 100%;
}

.container {
  // display: flex;
  width: 188000/1920vw;
  height: 88vh;
  // border: 1px solid white;
  margin: -1000/1080vh auto;
  
 
  .center {
    // border: 1px solid gold;
    width: 88000/1920vw;
   float: left;
  }

  .left,
  .right {
    width: 50000/1920vw;
    height: 90vh;
    // border: 1px solid red;
    float: left;
    position: relative;
    .item {
      width: 100%;
      height: 356/10.8vh;
      margin-top: 1%;
    }
     .item1 {
      width: 100%;
      height: 356/10.8vh;
      margin-bottom: 3%;
    }
    .item2 {
    width: 100%;
    height: 329/10.8vh;
    margin-bottom: 3%;
    }
    .lf
    {
   position:absolute;
   left:48000/1920vw;
   top:688/10.8vh;
    }
     .item3 {
      width: 100%;
      height: 278/10.8vh;
    }

      .item4 {
      width: 100%;
      height: 262/10.8vh;
      margin-bottom: 3%;
    }
     .rl
    {
   position:absolute;
    right:48000/1920vw;
   top:635/10.8vh;
    }
    .item5 {
    width: 100%;
    height: 367/10.8vh;
    margin-bottom: 3%;
    }
     .item6 {
      width: 100%;
      height: 320/10.8vh;
    }
  }
   .right
   {
      margin-top: 1600/1080vh
   }
    .left
   {
      margin-top:300/1080vh
   }
}
</style>



// WEBPACK FOOTER //
// index.vue?3b6b5744